<template>
  <div>
    <div class="footer">
      <div class="message">
        <div>
          <p>
            主管单位：中国社会科学院&nbsp;&nbsp;&nbsp;&nbsp;主办单位：中国社会科学院经济研究所
          </p>
          <p>
            国家社会科学基金资助期刊&nbsp;&nbsp;&nbsp;&nbsp;本刊不以任何形式收取版面费
          </p>
          <p>本网所登载文章仅代表作者观点，不代表本网观点或意见</p>
          <p>
            国际标准刊号：ISSN
            0577-9154&nbsp;&nbsp;&nbsp;&nbsp;国内统一刊号：CN11-1081/F&nbsp;&nbsp;&nbsp;&nbsp;国内邮发代号：2-251
            &nbsp;&nbsp;&nbsp;&nbsp;国外代号：M16
          </p>
          <p>
            地址：北京市西城区月坛北小街2号&nbsp;&nbsp;&nbsp;&nbsp;邮政编码：100836&nbsp;&nbsp;&nbsp;&nbsp;电话/传真：010-68034153
          </p>
          <p>本系统由北京博渊星辰网络科技有限公司设计开发 技术支持电话：010-63269626</p>
          <p>经济研究网站版权所有，未经允许，不得转载</p>

          <div class="btm">
            <a style="text-decoration: none">京ICP备 10211437号</a>
          </div>
        </div>
        <div style="margin-left: 130px" class="code">
          <div>
            <img src="@/assets/images/ewm.jpg" width="130px" />
          </div>
          <p
            style="
              line-height: 24px;
              margin-top: 5px;
              padding-left: 5px;
              text-align: center;
            "
          >
            本刊微信公众号：
          </p>
          <p style="line-height: 24px; text-align: center">erj_weixin</p>
        </div>
        <div style="margin-left: 50px" class="code">
          <div>
            <img src="@/assets/images/dy1.png" width="130px" />
          </div>
          <p
            style="
              line-height: 24px;
              margin-top: 5px;
              padding-left: 5px;
              text-align: center;
            "
          >
            本刊订阅电话:
          </p>
          <p style="line-height: 24px; text-align: center">010-59366555</p>
        </div>
      </div>
      <!-- <div class="line"></div> -->
    </div>
  </div>
</template>

<script setup></script>

<style lang="less" scoped>
.footer {
  min-width: 1280px;
  padding: 60px 0 100px;
  background-color: #074173;
  color: #fff;
  .message {
    display: flex;
    align-items: center;
    justify-content: center;
    > div:first-of-type {
      position: relative;
      p {
        font-family: PingFangSC, PingFang SC;
        font-size: 14px;
        color: #ffffff;
        line-height: 36px;
        text-align: center;
        font-style: normal;
      }
    }
    .code {
      p {
        // margin-top: 20px;
        color: #fff;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        line-height: 36px;
        text-align: center;
        font-style: normal;
      }
    }
  }
  .line {
    margin-top: 30px;
    border-bottom: 1px dashed #979797;
    opacity: 0.6;
  }
}

.btm {
  position: absolute;
  margin-top: 20px;
  height: 25px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 300;
  font-size: 14px;
  color: #fcfdff;
  line-height: 25px;
  text-align: center;
  font-style: normal;
  left: 50%;
  transform: translateX(-50%);
  bottom: -70px;
  a {
    color: #fcfdff;
    cursor: pointer;
  }
}
</style>
